import { IRootState } from '../reducer'
import { prefix } from './actions'

export const atlasPreviewState = (state: IRootState) => state[prefix]
